module.exports = __webpack_public_path__ + "static/media/599.702(13).3ce207f7.pdf";